export interface Article {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  category: string;
  views: number;
  rating: number;
  date: string;
  duration: string;
  tags: string[];
  content: string;
  source: string;
}

export const articles: Article[] = [
  {
    id: "article-1",
    title: "《流浪地球3》震撼来袭，国产科幻再创巅峰",
    description: "《流浪地球3》延续前作宏大世界观，讲述人类在星际旅程中遭遇全新挑战，视觉效果全面升级，剧情深度超越前作，成为2025年最受期待的国产科幻巨制。",
    thumbnail: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20spaceship%20flying%20through%20nebula%2C%20cinematic%20lighting%2C%20dramatic%20atmosphere%2C%20orange%20and%20gold%20warm%20tones%2C%20high%20quality%20film%20still%20style%2C%20clean%20composition%2C%20soft%20background&width=800&height=450&seq=article-thumb-01&orientation=landscape",
    category: "dianying",
    views: 1528000,
    rating: 9.3,
    date: "2026-07-28",
    duration: "148分钟",
    tags: ["科幻", "国产", "大片", "流浪地球"],
    content: "《流浪地球3》作为国产科幻电影的标杆之作，延续了前两部宏大的世界观设定。影片讲述了地球在星际流浪旅程中，人类面临前所未有的危机与挑战。导演在视觉特效上投入巨资，打造了令人叹为观止的宇宙场景。演员阵容更加强大，剧情深度和情感表达都达到了新的高度。影片在全球上映后获得了观众和影评人的一致好评，被誉为国产科幻电影的新里程碑。",
    source: "97视频影视资讯",
  },
  {
    id: "article-2",
    title: "《狂飙2》剧情全面解析，高启强归来",
    description: "备受期待的《狂飙2》终于开播，张颂文再度出演高启强，剧情更加扑朔迷离，扫黑风暴再度升级，首播即引爆全网热议。",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20scene%20with%20intense%20atmosphere%2C%20dark%20and%20moody%20lighting%2C%20professional%20film%20photography%2C%20warm%20amber%20tones%2C%20dramatic%20composition&width=800&height=450&seq=article-thumb-02&orientation=landscape",
    category: "dianshiju",
    views: 2350000,
    rating: 9.5,
    date: "2026-07-25",
    duration: "40集",
    tags: ["犯罪", "剧情", "国产剧", "狂飙"],
    content: "《狂飙2》承接第一部的时间线，讲述了扫黑除恶专项斗争进入新阶段的故事。张颂文饰演的高启强在狱中完成改造后，协助警方侦破了一系列重大案件。剧情紧凑，悬念迭起，演员演技炸裂。导演在叙事手法上更加成熟，将正邪对决的张力展现得淋漓尽致。该剧播出后迅速成为现象级作品，全网播放量突破百亿。",
    source: "97视频剧集推荐",
  },
  {
    id: "article-3",
    title: "《奔跑吧》第十二季开跑，全新阵容引爆笑点",
    description: "国民综艺《奔跑吧》第十二季正式开播，全新嘉宾阵容带来意想不到的化学反应，笑点密集，游戏环节全面升级。",
    thumbnail: "https://readdy.ai/api/search-image?query=Outdoor%20variety%20show%20scene%20with%20colorful%20set%20and%20energetic%20atmosphere%2C%20bright%20warm%20lighting%2C%20fun%20and%20playful%20mood%2C%20professional%20TV%20production%20quality%2C%20clean%20background&width=800&height=450&seq=article-thumb-03&orientation=landscape",
    category: "zongyi",
    views: 1890000,
    rating: 8.9,
    date: "2026-07-20",
    duration: "90分钟/期",
    tags: ["综艺", "搞笑", "户外", "奔跑吧"],
    content: "《奔跑吧》第十二季在万众期待中正式回归。本季节目在保留经典游戏环节的基础上，加入了更多创新元素。新加入的嘉宾为节目注入了新鲜活力，与老成员之间的互动笑料百出。节目组远赴多地取景，将当地文化特色融入游戏设计中，让观众在欢笑中感受不同地域的魅力。",
    source: "97视频综艺频道",
  },
  {
    id: "article-4",
    title: "《鬼灭之刃》最终季剧场版定档，粉丝狂欢",
    description: "现象级日漫《鬼灭之刃》最终季剧场版正式定档，无限城决战篇将在大银幕呈现，全球粉丝翘首以盼。",
    thumbnail: "https://readdy.ai/api/search-image?query=Anime%20action%20scene%20with%20swordsman%20in%20dramatic%20pose%2C%20vibrant%20warm%20colors%2C%20golden%20and%20red%20tones%2C%20Japanese%20animation%20style%2C%20epic%20cinematic%20composition%2C%20clean%20background&width=800&height=450&seq=article-thumb-04&orientation=landscape",
    category: "dongman",
    views: 980000,
    rating: 9.7,
    date: "2026-07-18",
    duration: "120分钟",
    tags: ["日漫", "剧场版", "鬼灭之刃", "热血"],
    content: "《鬼灭之刃》最终季剧场版「无限城决战篇」正式宣布定档。这部作品将在全球同步上映，为炭治郎与无惨的最终对决画上句号。制作团队表示，剧场版将采用最顶级的动画制作技术，战斗场面将比TV版更加震撼。粉丝们对这场视觉盛宴充满期待，预售票房已经创下多个纪录。",
    source: "97视频动漫资讯",
  },
  {
    id: "article-5",
    title: "《地球脉动III》震撼回归，4K画质呈现自然奇观",
    description: "BBC经典纪录片《地球脉动》第三季重磅回归，采用8K摄影技术拍摄，以4K超高清画质呈现在线观看，每一帧都是壁纸。",
    thumbnail: "https://readdy.ai/api/search-image?query=Stunning%20nature%20landscape%20with%20wildlife%20in%20golden%20hour%20light%2C%20documentary%20photography%20style%2C%20warm%20earthy%20tones%2C%20breathtaking%20vista%2C%20professional%20cinematography%2C%20clean%20composition&width=800&height=450&seq=article-thumb-05&orientation=landscape",
    category: "jilupian",
    views: 756000,
    rating: 9.8,
    date: "2026-07-15",
    duration: "8集",
    tags: ["纪录片", "自然", "BBC", "高清"],
    content: "《地球脉动》第三季历时五年拍摄，足迹遍及全球四十多个国家和地区。制作团队采用了最新的8K摄影技术，捕捉到了许多前所未见的自然奇观。从深海到高山，从极地到雨林，每一集都是视觉的饕餮盛宴。大卫·爱登堡爵士的解说依旧引人入胜，将自然的壮美与脆弱娓娓道来。",
    source: "97视频纪录片频道",
  },
  {
    id: "article-6",
    title: "《赘婿2》官宣开机，郭麒麟宋轶原班人马回归",
    description: "热播剧《赘婿》第二季正式开机，郭麒麟、宋轶等原班人马悉数回归，剧情将更加跌宕起伏，粉丝欢呼雀跃。",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20scene%20with%20elegant%20traditional%20setting%2C%20warm%20golden%20lighting%2C%20romantic%20atmosphere%2C%20soft%20focus%2C%20professional%20film%20photography%2C%20clean%20composition&width=800&height=450&seq=article-thumb-06&orientation=landscape",
    category: "dianshiju",
    views: 1270000,
    rating: 9.1,
    date: "2026-07-12",
    duration: "36集",
    tags: ["古装", "喜剧", "国产剧", "赘婿"],
    content: "《赘婿》第二季在粉丝的千呼万唤中正式开机。郭麒麟和宋轶将再度携手，延续第一季的精彩故事。据悉，第二季的剧情将更加宏大，宁毅将面临更大的挑战。制作团队在服化道方面全面升级，力求为观众呈现更加精美的视觉体验。该剧预计将在年底与观众见面。",
    source: "97视频剧集推荐",
  },
  {
    id: "article-7",
    title: "《封神第二部》定档暑期，神话史诗再续传奇",
    description: "乌尔善执导的《封神第二部》官宣暑期档上映，闻太师率大军兵临西岐，神仙大战即将全面爆发。",
    thumbnail: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20movie%20battle%20scene%20with%20warriors%20and%20magical%20elements%2C%20dramatic%20golden%20lighting%2C%20cinematic%20scale%2C%20warm%20tones%2C%20high%20quality%20film%20still%2C%20clean%20composition&width=800&height=450&seq=article-thumb-07&orientation=landscape",
    category: "dianying",
    views: 3100000,
    rating: 9.4,
    date: "2026-07-10",
    duration: "155分钟",
    tags: ["神话", "史诗", "国产", "封神"],
    content: "《封神第二部》正式定档2026年暑期档。导演乌尔善透露，第二部将聚焦西岐保卫战，闻太师率领的殷商大军与姜子牙领导的西岐阵营展开惊天对决。视觉特效团队耗时两年打造了数百个特效镜头，神仙斗法的场面将突破观众想象。演员阵容星光熠熠，演技与特效的完美结合令人期待。",
    source: "97视频影视资讯",
  },
  {
    id: "article-8",
    title: "《向往的生活》第九季回归，慢综艺治愈人心",
    description: "治愈系慢综艺《向往的生活》第九季温暖回归，新一季选址云南大理，在苍山洱海间继续传递生活之美。",
    thumbnail: "https://readdy.ai/api/search-image?query=Peaceful%20countryside%20landscape%20with%20traditional%20house%20and%20garden%2C%20warm%20sunset%20light%2C%20calm%20and%20healing%20atmosphere%2C%20pastoral%20aesthetic%2C%20soft%20natural%20colors%2C%20clean%20composition&width=800&height=450&seq=article-thumb-08&orientation=landscape",
    category: "zongyi",
    views: 1650000,
    rating: 9.2,
    date: "2026-07-08",
    duration: "100分钟/期",
    tags: ["综艺", "慢生活", "治愈", "向往的生活"],
    content: "《向往的生活》第九季来到了风景如画的云南大理。在苍山脚下、洱海之畔，蘑菇屋的家人们开始了新的田园生活。本季节目更加注重对当地文化的挖掘和呈现，嘉宾们不仅体验了白族扎染、三道茶等非遗文化，还将云南美食的魅力展现得淋漓尽致。节目继续以其独特的慢节奏治愈着都市人的心灵。",
    source: "97视频综艺频道",
  },
  {
    id: "article-9",
    title: "《咒术回战》第三季制作决定，涉谷事变篇来袭",
    description: "人气日漫《咒术回战》官方宣布第三季制作决定，将改编涉谷事变篇，MAPPA继续操刀，粉丝直呼过年了。",
    thumbnail: "https://readdy.ai/api/search-image?query=Japanese%20anime%20action%20scene%20with%20dynamic%20fighting%20pose%2C%20dark%20urban%20setting%2C%20vibrant%20warm%20color%20accents%2C%20stylish%20animation%20art%2C%20dramatic%20lighting%2C%20clean%20composition&width=800&height=450&seq=article-thumb-09&orientation=landscape",
    category: "dongman",
    views: 2100000,
    rating: 9.6,
    date: "2026-07-05",
    duration: "24集",
    tags: ["日漫", "热血", "咒术回战", "MAPPA"],
    content: "《咒术回战》第三季制作决定的消息让全球粉丝沸腾。第三季将改编漫画中最受好评的「涉谷事变」篇章，这一篇章被认为是整个系列的转折点。MAPPA工作室将继续负责动画制作，导演表示将全力以赴打造最震撼的战斗场面。五条悟的粉丝们已经准备好纸巾，为即将到来的名场面做好准备。",
    source: "97视频动漫资讯",
  },
  {
    id: "article-10",
    title: "《舌尖上的中国4》开播，美食纪录片天花板回归",
    description: "陈晓卿团队打造的《舌尖上的中国》第四季正式开播，以全新视角探索中国美食背后的文化与故事。",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20cuisine%20close-up%20with%20steaming%20hot%20dish%2C%20warm%20appetizing%20colors%2C%20golden%20lighting%2C%20food%20documentary%20photography%20style%2C%20rich%20textures%2C%20clean%20composition&width=800&height=450&seq=article-thumb-10&orientation=landscape",
    category: "jilupian",
    views: 890000,
    rating: 9.5,
    date: "2026-07-02",
    duration: "10集",
    tags: ["纪录片", "美食", "舌尖", "文化"],
    content: "《舌尖上的中国》第四季带着观众走遍中国大江南北，探寻那些即将消失的传统美食手艺。陈晓卿导演团队以独特的叙事手法，将食物与人文故事完美融合。本季特别关注年轻一代厨师对传统美食的创新演绎，以及食物在连接人与人之间情感中的重要作用。每一道菜背后都有一段动人的故事。",
    source: "97视频纪录片频道",
  },
  {
    id: "article-11",
    title: "《唐朝诡事录2》开播，古装悬疑再掀热潮",
    description: "杨旭文、杨志刚主演的《唐朝诡事录》第二季正式开播，诡谲案件搭配盛唐风貌，悬疑氛围拉满。",
    thumbnail: "https://readdy.ai/api/search-image?query=Mysterious%20ancient%20Chinese%20palace%20interior%20with%20candlelight%2C%20dark%20and%20atmospheric%2C%20Tang%20dynasty%20aesthetic%2C%20warm%20golden%20tones%2C%20suspenseful%20mood%2C%20professional%20film%20photography&width=800&height=450&seq=article-thumb-11&orientation=landscape",
    category: "dianshiju",
    views: 1100000,
    rating: 8.8,
    date: "2026-06-28",
    duration: "36集",
    tags: ["古装", "悬疑", "国产剧", "唐朝"],
    content: "《唐朝诡事录》第二季延续第一季的悬疑风格，苏无名和卢凌风再度联手破案。第二季的案件设计更加精巧，每个案件都巧妙融入了唐朝的历史文化元素。制作团队在场景和道具上精益求精，完美还原了盛唐时期的繁华景象。演员的表演也更加成熟，将角色的复杂性展现得入木三分。",
    source: "97视频剧集推荐",
  },
  {
    id: "article-12",
    title: "《大鱼海棠2》官宣，国产动画再攀高峰",
    description: "经典国产动画《大鱼海棠》续集正式官宣，原班制作团队回归，将讲述椿和湫前世今生的全新故事。",
    thumbnail: "https://readdy.ai/api/search-image?query=Magical%20underwater%20fantasy%20world%20with%20glowing%20creatures%2C%20dreamy%20atmosphere%2C%20Chinese%20animation%20art%20style%2C%20warm%20golden%20and%20teal%20tones%2C%20ethereal%20lighting%2C%20clean%20composition&width=800&height=450&seq=article-thumb-12&orientation=landscape",
    category: "dongman",
    views: 870000,
    rating: 9.0,
    date: "2026-06-25",
    duration: "110分钟",
    tags: ["国漫", "动画电影", "大鱼海棠", "奇幻"],
    content: "《大鱼海棠2》官方宣布正式立项。导演梁旋和张春将再度联手，为观众呈现一个更加宏大的奇幻世界。据悉，续集将深入探索椿和湫的前世今生，故事将跨越不同的时空维度。制作团队表示，将采用最新的动画渲染技术，力求在视觉上给观众带来全新的震撼体验。这部承载着无数观众期待的国漫之光即将再度绽放。",
    source: "97视频动漫资讯",
  },
  {
    id: "article-13",
    title: "《密室大逃脱》第六季，杨幂邓伦领衔烧脑之旅",
    description: "热门推理综艺《密室大逃脱》第六季强势回归，杨幂、邓伦等老成员悉数回归，全新密室设计挑战智商极限。",
    thumbnail: "https://readdy.ai/api/search-image?query=Mysterious%20escape%20room%20set%20with%20puzzles%20and%20clues%2C%20dim%20atmospheric%20lighting%2C%20warm%20amber%20accents%2C%20adventure%20game%20show%20aesthetic%2C%20professional%20TV%20production%2C%20clean%20composition&width=800&height=450&seq=article-thumb-13&orientation=landscape",
    category: "zongyi",
    views: 1320000,
    rating: 9.1,
    date: "2026-06-22",
    duration: "85分钟/期",
    tags: ["综艺", "推理", "密室", "烧脑"],
    content: "《密室大逃脱》第六季带来了更加精妙的密室设计。节目组邀请了国际顶尖的密室设计师参与创作，每个密室都融合了高科技元素和传统文化符号。杨幂、邓伦等老成员的默契配合依旧是节目最大的看点。新加入的嘉宾也为团队带来了全新的解题思路，让整个逃脱过程更加精彩刺激。",
    source: "97视频综艺频道",
  },
  {
    id: "article-14",
    title: "《三大队》电影版口碑炸裂，张译演技封神",
    description: "张译主演的犯罪剧情片《三大队》上映后口碑持续发酵，真实事件改编引发观众强烈共鸣，演技获赞封神之作。",
    thumbnail: "https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20drama%20film%20scene%20with%20police%20officer%2C%20gritty%20realistic%20style%2C%20warm%20urban%20night%20lighting%2C%20emotional%20atmosphere%2C%20professional%20cinematography%2C%20clean%20composition&width=800&height=450&seq=article-thumb-14&orientation=landscape",
    category: "dianying",
    views: 1980000,
    rating: 9.6,
    date: "2026-06-18",
    duration: "132分钟",
    tags: ["犯罪", "剧情", "国产", "张译"],
    content: "《三大队》改编自真实事件，讲述了刑警程兵在追捕逃犯过程中经历的种种艰辛。张译的表演堪称教科书级别，将一个执着、坚韧、不向命运低头的警察形象刻画得入木三分。影片采用纪实风格的拍摄手法，让观众仿佛身临其境。影片上映后不仅票房大卖，更引发了社会对警察群体的广泛关注和讨论。",
    source: "97视频影视资讯",
  },
  {
    id: "article-15",
    title: "《蓝色星球III》深海探秘，4K镜头下的未知世界",
    description: "BBC《蓝色星球》第三季深入从未被拍摄过的深海区域，4K超高清摄影机记录下令人叹为观止的海底奇观。",
    thumbnail: "https://readdy.ai/api/search-image?query=Deep%20ocean%20underwater%20scene%20with%20bioluminescent%20creatures%2C%20mysterious%20blue%20and%20gold%20light%2C%20documentary%20cinematography%20style%2C%20breathtaking%20marine%20life%2C%20clean%20composition%2C%20warm%20accents&width=800&height=450&seq=article-thumb-15&orientation=landscape",
    category: "jilupian",
    views: 670000,
    rating: 9.7,
    date: "2026-06-15",
    duration: "7集",
    tags: ["纪录片", "海洋", "BBC", "高清"],
    content: "《蓝色星球》第三季将镜头对准了地球上最神秘的区域——深海。摄制组使用了特制的深海潜水器和4K超高清摄影设备，首次记录下了许多深海生物的珍贵影像。从发光的深海水母到巨型鱿鱼，每一帧画面都让人惊叹于大自然的鬼斧神工。这部纪录片不仅是一场视觉盛宴，更是对海洋生态保护的一次深刻呼吁。",
    source: "97视频纪录片频道",
  },
  {
    id: "article-16",
    title: "《庆余年3》剧本完成，张若昀确认回归",
    description: "《庆余年》第三季剧本创作已完成，张若昀确认继续出演范闲，剧情将迎来全书最高潮部分。",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20scene%20with%20palace%20setting%2C%20epic%20atmosphere%2C%20warm%20golden%20lighting%2C%20majestic%20composition%2C%20professional%20film%20photography%2C%20clean%20background&width=800&height=450&seq=article-thumb-16&orientation=landscape",
    category: "dianshiju",
    views: 2980000,
    rating: 9.3,
    date: "2026-06-10",
    duration: "40集",
    tags: ["古装", "权谋", "国产剧", "庆余年"],
    content: "《庆余年》第三季的剧本创作已经全部完成。编剧王倦透露，第三季将改编原著中最精彩的大东山之战和京都叛乱等篇章。张若昀确认回归出演范闲，将继续在权谋与武力的交织中书写传奇。制作方表示，第三季在制作规模上将有质的飞跃，战争场面和视觉效果都将达到国产剧的新高度。",
    source: "97视频剧集推荐",
  },
  {
    id: "article-17",
    title: "《铃芽之旅》导演新海诚新作宣布，粉丝期待值拉满",
    description: "新海诚导演在《铃芽之旅》全球大获成功后，正式宣布全新动画电影项目启动，主题暂未公开引发无限遐想。",
    thumbnail: "https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20animation%20style%20sky%20with%20dramatic%20clouds%2C%20warm%20sunset%20colors%2C%20dreamy%20atmosphere%2C%20cinematic%20composition%2C%20Makoto%20Shinkai%20aesthetic%2C%20clean%20background&width=800&height=450&seq=article-thumb-17&orientation=landscape",
    category: "dongman",
    views: 1450000,
    rating: 9.5,
    date: "2026-06-08",
    duration: "待定",
    tags: ["日漫", "动画电影", "新海诚", "治愈"],
    content: "新海诚导演在《铃芽之旅》取得全球票房佳绩后，正式宣布了全新动画电影项目。虽然目前主题尚未公开，但新海诚表示这将是一部不同于以往作品的全新尝试。制作团队已经集结完毕，前期美术设计正在进行中。粉丝们纷纷猜测新作主题，从太空冒险到历史穿越，各种猜想在社交媒体上引发热烈讨论。",
    source: "97视频动漫资讯",
  },
  {
    id: "article-18",
    title: "《歌手2026》重磅回归，全新赛制引爆音乐热潮",
    description: "殿堂级音乐竞演节目《歌手》2026年全面升级回归，全新赛制和国际化选手阵容，音乐盛宴即将开启。",
    thumbnail: "https://readdy.ai/api/search-image?query=Grand%20music%20stage%20with%20dramatic%20lighting%20and%20spotlights%2C%20concert%20atmosphere%2C%20warm%20golden%20and%20amber%20tones%2C%20professional%20TV%20production%2C%20elegant%20composition%2C%20clean%20background&width=800&height=450&seq=article-thumb-18&orientation=landscape",
    category: "zongyi",
    views: 2560000,
    rating: 9.4,
    date: "2026-06-05",
    duration: "120分钟/期",
    tags: ["综艺", "音乐", "竞演", "歌手"],
    content: "《歌手2026》以全新面貌重磅回归。本季节目在赛制上进行了大胆创新，引入了国际对战和跨界合作等新环节。参赛阵容涵盖国内外顶尖歌手，从流行到古典，从民谣到摇滚，音乐风格的多样性前所未有。舞台设计和音响系统全面升级，力求为观众带来殿堂级的音乐享受。",
    source: "97视频综艺频道",
  },
];

export const getArticlesByCategory = (slug: string): Article[] => {
  return articles.filter((a) => a.category === slug);
};

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((a) => a.id === id);
};

export const getRelatedArticles = (article: Article, count: number = 4): Article[] => {
  return articles
    .filter((a) => a.id !== article.id && a.category === article.category)
    .slice(0, count);
};

export const getFeaturedArticles = (count: number = 6): Article[] => {
  return [...articles].sort((a, b) => b.views - a.views).slice(0, count);
};

export const getLatestArticles = (count: number = 8): Article[] => {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, count);
};